import { find, sortBy } from 'lodash';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

import { getClientStoreNameTranslation } from '@commons/utils/translations';
import { ListView } from '@commons/utils/styledLibraryComponents';
import { LISTVIEW_NO_TOP_PADDING } from '@commons/constants/listViewProps';
import GeneralEmptyStateListView from '@commons/GeneralEmptyStateListView';

import { Container } from './styledComponents';
import { getColumns } from './utils/columns';

const KitchenProductAssociatedCentralKitchensSection = (props) => {
  const {
    availableCentralKitchens,
    selectedCentralKitchens,
    setSelectedCentralKitchens,
    storeName,
  } = props;

  const clientStoreNamePlural = getClientStoreNameTranslation(storeName, true);

  const [columns] = useState(getColumns(clientStoreNamePlural));
  const [centralKitchens, setCentralKitchens] = useState([]);

  /*
    isRowSelected only restores the selection when coming back to this step; the ListView keeps
    the live selection internally, so data must not be rebuilt on selection changes (new row
    references would reset it).
  */
  useEffect(() => {
    const formattedCentralKitchens = availableCentralKitchens.map((centralKitchen) => ({
      ...centralKitchen,
      isRowSelected: !!find(selectedCentralKitchens, { id: centralKitchen.id }),
    }));

    setCentralKitchens(sortBy(formattedCentralKitchens, 'name'));
  }, [availableCentralKitchens]);

  if (!availableCentralKitchens.length) {
    return (
      <GeneralEmptyStateListView
        icon={'/images/inpulse-icon-no-data.svg'}
        renderAction={() => null}
        subtitle={i18next.t('ADMIN.CENTRAL_PRODUCTS.NO_ACTIVE_CENTRAL_KITCHEN_SUBTITLE')}
        title={i18next.t('ADMIN.CENTRAL_PRODUCTS.NO_ACTIVE_CENTRAL_KITCHEN_TITLE')}
      />
    );
  }

  return (
    <Container>
      <ListView
        columns={columns}
        data={centralKitchens}
        defaultOrderBy={'name'}
        defaultOrderType={'asc'}
        padding={LISTVIEW_NO_TOP_PADDING}
        placeholderShape={i18next.t('GENERAL.SEARCH')}
        setSelectedItems={setSelectedCentralKitchens}
        disableFooter
        forceEnableSelection
      />
    </Container>
  );
};

export default KitchenProductAssociatedCentralKitchensSection;
